/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsHoopListItem,
    ControlcenterMelcoModelsHoopListItemFromJSON,
    ControlcenterMelcoModelsHoopListItemFromJSONTyped,
    ControlcenterMelcoModelsHoopListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItem
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItem {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsHoopListItem>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItem
     */
    list: Array<ControlcenterMelcoModelsHoopListItem>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItem
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItem
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItemFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItem {
    return ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItemFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsHoopListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItemToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsHoopListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsHoopListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


